import React from 'react';
import {
    MESSAGE_TIERED_LOYALTY_METRIC_CREATE_ERROR,
    MESSAGE_TIERED_LOYALTY_METRIC_CREATE_SUCCESS
} from 'config/messages';
import { useSnackbar } from 'notistack';
import logger from 'lib/logger';
import { UserMetricDefinition, UserMetricResource } from 'components/metrics/model';
import { metricsApi } from 'components/metrics/metricsApi';

export function useTieredLoyaltyMetricEdit(
    metricDefinition: UserMetricDefinition | undefined,
    setDefinition: (value: UserMetricDefinition) => void
) {
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const handleOpen = React.useCallback(() => {
        setOpen(true);
    }, []);
    const handleClose = React.useCallback(() => {
        setOpen(false);
    }, []);
    const handleSubmit = React.useCallback(
        async (metric: UserMetricResource) => {
            setLoading(true);
            const metricId = metric.name.replaceAll(' ', '_');
            const result = await metricsApi.addMetric(metricDefinition?._id, metricId, metric);
            setLoading(false);
            if (!result.ok) {
                logger.error(result.body.message, result.body);
                enqueueSnackbar(MESSAGE_TIERED_LOYALTY_METRIC_CREATE_ERROR, { variant: 'error' });
                return;
            }
            enqueueSnackbar(MESSAGE_TIERED_LOYALTY_METRIC_CREATE_SUCCESS, { variant: 'success' });
            setDefinition(result.body);
            setOpen(false);
        },
        [enqueueSnackbar, metricDefinition?._id, setDefinition]
    );
    return {
        metricsModalOpen: open,
        handleMetricEditOpen: handleOpen,
        handleMetricEditClose: handleClose,
        handleMetricEditSubmit: handleSubmit,
        loading
    };
}
